module.exports = __webpack_public_path__ + "static/media/testfile_parametricHarmonization.1cb91d2d.zip";